import { Link } from "react-router-dom";
import { Logo } from "@/components/site/Logo";
import { EMAIL, PHONE, PHONE_HREF } from "@/lib/site";

export default function Impressum() {
    return (
        <div className="min-h-screen bg-[#120E09] px-6 py-16" data-testid="impressum-page">
            <div className="mx-auto max-w-2xl">
                <Link to="/" aria-label="Zur Startseite"><Logo size={64} /></Link>
                <h1 className="mt-12 mb-10 font-display text-4xl font-extrabold uppercase tracking-tight text-[#EDE6DA]">Impressum</h1>
                <div className="space-y-8 rounded border border-[#2E2517] bg-[#1B150E] p-8 text-sm leading-relaxed text-[#D9D2C4]">
                    <div>
                        <h2 className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#C88A45]">Angaben gemäß § 5 DDG</h2>
                        <p>
                            KischioWood — Hannes Kischio<br />
                            Neu Placht 4E<br />
                            17268 Templin
                        </p>
                    </div>
                    <div>
                        <h2 className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#C88A45]">Kontakt</h2>
                        <p>
                            Telefon: <a href={PHONE_HREF} className="text-[#C88A45] hover:underline">{PHONE}</a><br />
                            E-Mail: <a href={`mailto:${EMAIL}`} className="text-[#C88A45] hover:underline">{EMAIL}</a>
                        </p>
                    </div>
                    <div>
                        <h2 className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#C88A45]">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
                        <p>Hannes Kischio, Anschrift wie oben</p>
                    </div>
                    <div>
                        <h2 className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#C88A45]">Haftung für Inhalte</h2>
                        <p>
                            Alle Angaben auf dieser Website sind unverbindlich. Preise verstehen sich als Richtwerte
                            und werden individuell nach Baumart, Trocknung und Entfernung bestätigt.
                        </p>
                    </div>
                </div>
                <Link to="/" data-testid="impressum-back-link" className="mt-10 inline-block text-xs text-[#9C917D] transition-colors duration-200 hover:text-[#C88A45]">
                    ← Zurück zur Website
                </Link>
            </div>
        </div>
    );
}
